import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export function Eyebrow({ children, className = "", dark = false }) {
  return (
    <div
      className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] ${
        dark ? "text-gold" : "text-teal"
      } ${className}`}
    >
      <span className={`h-px w-8 ${dark ? "bg-gold/60" : "bg-teal/50"}`} />
      {children}
    </div>
  );
}

export function PrimaryButton({ to, href, children, testid, className = "", ...rest }) {
  const cls = `inline-flex items-center justify-center gap-2 rounded-full bg-navy px-7 py-3.5 text-sm font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5 hover:bg-navy-950 ${className}`;
  if (href)
    return (
      <a href={href} data-testid={testid} className={cls} {...rest}>
        {children}
      </a>
    );
  return (
    <Link to={to} data-testid={testid} className={cls} {...rest}>
      {children}
    </Link>
  );
}

export function GhostLink({ to, children, testid, className = "" }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`group inline-flex items-center gap-2 text-sm font-semibold text-navy transition-colors duration-300 hover:text-gold ${className}`}
    >
      {children}
      <ArrowRight
        size={17}
        weight="bold"
        className="transition-transform duration-300 group-hover:translate-x-1"
      />
    </Link>
  );
}
